import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { API } from "../App";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Mail, ArrowLeft, Check } from "lucide-react";

const LOGO_URL = "/logo.png";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSubmitted(true);
    } catch (error) {
      // Still show success for security reasons
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F7F2] flex items-center justify-center p-8" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8">
          <img src={LOGO_URL} alt="Trish Drives Honda" className="h-16" />
        </Link>
        
        <div className="bg-white rounded-3xl p-8 md:p-10 shadow-lg border border-[#E5E7EB]/50">
          {submitted ? (
            <div className="text-center">
              <div className="w-20 h-20 rounded-full bg-[#388E3C]/10 flex items-center justify-center mx-auto mb-6">
                <Check className="w-10 h-10 text-[#388E3C]" />
              </div>
              <h1 className="font-heading text-2xl font-bold text-[#2C2420] mb-4">
                Check Your Email
              </h1>
              <p className="text-[#6B5E55] mb-8">
                If an account exists for {email}, you'll receive a password reset link shortly.
              </p>
              <Link to="/login" className="btn-secondary inline-flex items-center gap-2" data-testid="back-to-login-btn">
                <ArrowLeft className="w-4 h-4" />
                Back to Login
              </Link>
            </div>
          ) : (
            <>
              <h1 className="font-heading text-3xl font-bold text-[#2C2420] text-center mb-2">
                Forgot Password?
              </h1>
              <p className="text-[#6B5E55] text-center mb-8">
                Enter your email and we'll send you a reset link
              </p>
              
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="form-group">
                  <Label className="form-label">Email Address</Label>
                  <div className="relative">
                    <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#6B5E55]" />
                    <Input
                      type="email"
                      placeholder="john@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="pl-12 form-input"
                      data-testid="input-email"
                    />
                  </div>
                </div>
                
                <Button 
                  type="submit" 
                  className="w-full btn-primary"
                  disabled={loading}
                  data-testid="reset-btn"
                >
                  {loading ? "Sending..." : "Send Reset Link"}
                </Button>
              </form>
              
              <div className="text-center mt-8">
                <Link 
                  to="/login" 
                  className="inline-flex items-center gap-2 text-[#8D7B68] hover:underline"
                  data-testid="back-link"
                >
                  <ArrowLeft className="w-4 h-4" />
                  Back to Login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
